export default __webpack_public_path__ + "static/media/profile.36e72d7d.png";